import { html, nothing, TemplateResult } from "lit-html";
import {
  InputComponent,
  ButtonComponent,
  LabelComponent
} from '@components/common';

export const EmailTypeaheadTemplate = (configs: IEmailTypeaheadComponent, props: IEmailTypeaheadProps): TemplateResult => {

  const {
    email,
    suggestedEmailValue,
    handleInputChange,
    handleKeyDown,
  } = configs;

  const { placeholder, labelText } = props;

  return html`
  ${InputComponent({
    type: "email",
    name: "email",
    value: email.value,
    placeholder,
    cssClasses: `jr-input jr-input--autocomplete jr-input-material ts-email-typeahead
        ${!email.isValid ? 'jr-input--invalid' : ''}`,
    eventHandlers: {
      onInput: handleInputChange,
      onKeyDown: handleKeyDown,
    },
    options: {
      autoComplete: "off",
      tabIndex: "-1",
      ariaHidden: "off",
      autofocus: true,
      required: true
    }
  })}
  ${!email.isValid
      ?
      ButtonComponent({
        type: "button",
        cssClasses: "warning-button"
      })
      :
      nothing}
  ${LabelComponent({
        cssClasses: "proposal-form__label",
        labelText
      })}
  ${InputComponent({
        type: "text",
        cssClasses: "jr-typeahead-input",
        value: suggestedEmailValue
      })}
  `;
}